import type { PropsWithChildren } from "react";
import { cn } from "../utils";

/** Props Interface */
interface InputGroupProps extends PropsWithChildren {}

export function InputGroup({ children }: InputGroupProps) {
	return <div className={cn("h-stack w-full gap-0", "input-group")}>{children}</div>;
}
